<div *ngIf="contactsDataResponse" class="contactos">
  <!-- Contactos Generalesa -->
  <div class="card contactos-generales">
    <h5 class="title">{{ title }}</h5>
    <div class="info">
      <div class="row">
        <div class="col-4 label">Centro contacto</div>
        <div class="col-8 value">
          {{
            contactsDataResponse.contactNumber[0].content.replaceAll("-", " ")
          }}
        </div>
      </div>
      <div class="row">
        <div class="col-4 label">Asistencia Virtual</div>
        <div class="col-8 value">
          {{
            getContactContentById(24).replaceAll("-", " ")
          }}
        </div>
      </div>
      <div class="row">
        <div class="col-4 label">Servicio al cliente</div>
        <div class="col-8 value">
          {{ "servicioalcliente@segurosreservas.com" }}
        </div>
      </div>
      <div class="row">
        <div class="col-4 label">Autorizaciones médicas</div>
        <div class="col-8 value">
          {{
            contactsDataResponse.contactNumber[2].content.replaceAll("-", " ")
          }}
        </div>
      </div>
      <div class="row">
        <div class="col-4 label">Asistencia Funeraria</div>
        <div class="col-8 value">
          {{
            contactsDataResponse.contactNumber[7].content.replaceAll("-", " ")
          }}
        </div>
      </div>
    </div>
  </div>

  <!-- Agentes -->
  <div class="card agentes">
    <h5 class="title">Agentes</h5>
    <div class="info">
      <div class="row">
        <div class="col-4 label">Agencia de Daños</div>
        <div class="col-8 value">{{ contactsData?.damagesAgent }}</div>
      </div>
      <div class="row">
        <div class="col-4 label">Agencia de Vida</div>
        <div class="col-8 value">{{ contactsData?.lifeAgent }}</div>
      </div>
      <div class="row">
        <div class="col-4 label">Oficial de Cobros</div>
        <div class="col-8 value">{{ contactsData?.collectionAgent }}</div>
      </div>
    </div>
  </div>

  <!-- Viajes Reservas Asistencia -->
  <div class="card viajes-asistencia">
    <h5 class="title">Viajes Reservas Asistencia</h5>
    <div class="info">
      <div class="row">
        <div class="col-4 label">Whatsapp</div>
        <div class="col-8 value">
          {{ contactsDataResponse.contactNumber[4].content }}
        </div>
      </div>
      <div class="row">
        <div class="col-4 label">
          {{ contactsDataResponse.contactNumber[5].title }}
        </div>
        <div class="col-8 value">
          {{ contactsDataResponse.contactNumber[5].content }}
        </div>
      </div>
      <div class="row">
        <div class="col-4 label">
          {{ contactsDataResponse.contactNumber[6].title }}
        </div>
        <div class="col-8 value">
          {{ contactsDataResponse.contactNumber[6].content }}
        </div>
      </div>
      <div class="row">
        <div class="col-4 label">Reclamaciones</div>
        <div class="col-8 value">
          {{ "claims@redbridge.cc | claimsmiami@redbridge.cc" }}
        </div>
      </div>
    </div>
  </div>

  <!-- Sucursales -->
  <div class="card sucursales">
    <h5 class="title">Sucursales</h5>
    <div class="info">
      <div class="row">
        <div class="col-3 label">Zona</div>
        <div class="col-19">
          <select
            [(ngModel)]="selectedTerritory"
            (change)="getBranchesByTerritory(selectedTerritory)"
            class="input-field"
            name="sucursales"
          >
            @for (territory of branchesData?.territories || []; track
            territory.territoryCode) {
            <option value="{{ territory.territoryCode }}">
              {{ territory.territoryDescription }}
            </option>
            }
          </select>
        </div>
      </div>
      @for (branch of filteredBranches; track $index) {
      <div class="row">
        <div class="col-3 label"></div>
        <div class="col-9 value">
          <strong>{{ branch.branchDescription }}</strong>
          <p>{{ branch.street }}</p>
        </div>
      </div>
      }
    </div>
  </div>

  <!-- Mapa de sucursales -->
  <div class="card mapa">
    <h5 class="title">Ubicación de sucursales</h5>
    <app-mapa-sucursales
      class="map-container"
      [branches]="filteredBranches"
    ></app-mapa-sucursales>
  </div>

  <!-- Rescate 365 -->
  <div class="card rescate-365">
    <h5 class="title">{{ contactsDataResponse.contactNumber[1].title }}</h5>
    <div class="info">
      <div class="row">
        <div class="col-4 label">Contacto</div>
        <div class="col-8 value">
          {{
            contactsDataResponse.contactNumber[1].content.replaceAll("-", " ")
          }}
        </div>
      </div>
      <div class="row">
        <div class="col-4 label">Otros</div>
        <a
          href="https://www.rescate365.com/"
          target="_blank"
          class="col-8 value"
          ><span class="link">Ver página web</span></a
        >
      </div>
    </div>
  </div>
</div>
